import React from "react";
import { BlockMath } from "react-katex";

function getLatexString(dividend, divisor) {
  let latexExpressionTemplate = `\\frac{\\text{\\textit{${dividend}}} \\ast \\textit{100}}{\\text{\\textit{${divisor}}}}`;
  return latexExpressionTemplate;
}

const de = (
  <div>
    <p>
      Der mittlere Bürostundensatz ermittelt die tatsächlichen Kosten einer Stunde Arbeitsleistung, indem die gesamten Selbstkosten (Gemein- und
      Lohnkosten) durch die Anzahl der verrechenbaren Projektstunden geteilt werden.
    </p>
    <BlockMath>{getLatexString("Selbstkosten", "auftragsbezogene Präsenzzeit")}</BlockMath>
  </div>
);

const fr = (
  <div>
    <p>
      Le taux horaire moyen du bureau permet de déterminer les coûts réels d’une heure de travail en divisant l’en- semble des coûts du bureau et du
      personnel par le nombre d’heures de projet facturables.
    </p>
    <BlockMath>{getLatexString("Coûts de revient", "Temps de présence lié aux mandats")}</BlockMath>
  </div>
);

const it = (
  <div>
    <p>
      La tariffa oraria media dello studio di progettazione permette di determinare le spese effettive di un’ora di prestazione lavorativa, dividendo
      le spese totali e i costi del personale dello studio di progettazione per il numero di ore fatturabili di un progetto.
    </p>
    <BlockMath>{getLatexString("Spese proprie", "Tempo di presenza rif a mandati")}</BlockMath>
  </div>
);

const en = (
  <div>
    <p>
      Firm’s average hourly rate determines the actual cost of one hour of work by dividing total office and person- nel costs by the number of
      billable project hours.
    </p>
    <BlockMath>{getLatexString("Cost price", "Mandate-related attendance time")}</BlockMath>
  </div>
);

let text = {
  de,
  fr,
  it,
  en,
};

export default text;
